import type { EndFlowNode } from '@lighthouse/shared'
import { EndNodeType } from '@lighthouse/shared'
import isDeepEqual from 'fast-deep-equal'
import React, { memo } from 'react'
import styled from 'styled-components'

import { NodeTargetHandle } from '../Handle'
import NodeCard from './NodeCards'
import * as SC from './styles'

interface EndNodeProps extends EndFlowNode {
    isConnectable?: boolean
}

const SCxEndNodeContent = styled.div`
    display: flex;
    box-sizing: border-box;
    align-items: center;
`

const EndNode: React.FC<EndNodeProps> = props => {
    const { data, selected } = props
    const { status } = data
    return (
        <SC.NodeWrapper selected={selected} status={status?.status}>
            <NodeTargetHandle {...props} />
            <SCxEndNodeContent>
                <NodeCard nodeType={EndNodeType.END} data={data} />
            </SCxEndNodeContent>
        </SC.NodeWrapper>
    )
}

export default memo(EndNode, (prevProps, nextProps) => {
    return isDeepEqual(prevProps.data, nextProps.data) && nextProps.selected === prevProps.selected
})
